import { FeedbackFormData } from '../../components/feedback-form/feedback-types';

export const slurryFormData: FeedbackFormData = {
  id: 'slurry-optimization',
  title: $localize`We'd like to hear some more`,
  subtitle: $localize`We promise it will only take a few minutes of your time, and your answers are of high value for us`,
  questions: [
    [
      {
        id: 'agree-extend',
        title: $localize`To what extent do you agree with the following statements?`,
        type: 'radio-block',
        options: [
          { id: 'save-time', label: $localize`Using a tool like this will save me time` },
          { id: 'easier', label: $localize`Slurry application will be easier with this tool` },
          { id: 'less-damage', label: $localize`A tool like this will result in less damage of the field` },
          { id: 'new-drivers', label: $localize`It will be easier for new drivers to do the job` },
          { id: 'optimize', label: $localize`Overall a tool like this will optimize my slurry application` },
        ],
      },
      {
        id: 'would-use',
        title: $localize`Why would or wouldn't you use a tool like this?`,
        subtitle: $localize`Please add a comment below`,
        type: 'textarea',
      },
    ],
    [
      {
        id: 'current-practice',
        title: $localize`What do you do when applying slurry today?`,
        subtitle: $localize`Select the answer that best applies to your current practice`,
        type: 'radio',
        options: [
          {
            id: 'no-adjustment',
            label: $localize`I never adjust the application rate. After reloading I continue from the spot where I left off.`,
          },
          {
            id: 'track-end',
            label: $localize`As I approach the end of the track, I adjust the application rate to finish without running out of material.`,
          },
          {
            id: 'plan-ahead',
            label: $localize`While driving I plan two or more tracks ahead and adjust the application rate on the go.`,
          },
        ],
      },
    ],
    [
      {
        id: 'decrease-rate',
        title: $localize`How much will you be willing to decrease the application rate?`,
        subtitle: $localize`Select the maximum in percentage that you would allow`,
        type: 'radio',
        options: [
          { id: '0', label: $localize`0% - I would never decrease the application rate` },
          { id: '5', label: $localize`5%` },
          { id: '10', label: $localize`10%` },
          { id: '15', label: $localize`15%` },
          { id: '20', label: $localize`20%` },
        ],
        wildcard: {
          label: $localize`More than 20%:`,
          placeholder: $localize`Enter your maximum %`,
        },
      },
      {
        id: 'increase-rate',
        title: $localize`How much will you be willing to increase the application rate?`,
        subtitle: $localize`Select the maximum in percentage that you would allow`,
        type: 'radio',
        options: [
          { id: '0', label: $localize`0% - I would never increase the application rate` },
          { id: '5', label: $localize`5%` },
          { id: '10', label: $localize`10%` },
          { id: '15', label: $localize`15%` },
          { id: '20', label: $localize`20%` },
        ],
        wildcard: {
          label: $localize`More than 20%:`,
          placeholder: $localize`Enter your maximum %`,
        },
      },
    ],
    [
      {
        id: 'output-usage',
        title: $localize`How do you imagine using the output of this tool?`,
        subtitle: $localize`Select one or more answers`,
        type: 'check-block',
        options: [
          { id: 'printout', label: $localize`Printout: I will print the zones and application rates on paper` },
          {
            id: 'app',
            label: $localize`App: I will see the zones and application rates in app on my tablet or smartphone`,
          },
          {
            id: 'taskfile',
            label: $localize`Taskfile: I will download an ISOXML file with zones and application rates, and upload it in the tractor terminal`,
          },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: $localize`Please specify`,
        },
      },
      {
        id: 'challenges',
        title: $localize`What would be the biggest challenges for you to start using a tool like this?`,
        subtitle: $localize`Select one or more answers`,
        type: 'check-block',
        options: [
          { id: 'none', label: $localize`I don't see any big challenges` },
          { id: 'planning', label: $localize`I am not used to detailed planning in advance` },
          { id: 'guidance', label: $localize`I don't use guidance lines` },
          { id: 'wrong-adjustment', label: $localize`I consider it wrong to adjust the application rate` },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: $localize`Please specify`,
        },
      },
    ],
    [
      {
        id: 'pricing',
        title: $localize`At what price would you consider a product like this?`,
        subtitle: $localize`Please add a price in the four categories below, based on what you currently know about the idea - don't worry, you can't do anything wrong.`,
        type: 'pricing',
        options: [
          {
            id: 'too-low',
            label: $localize`At what price would you think the price is too low, that the product must be of bad quality? (Too cheap)`,
          },
          {
            id: 'good-value',
            label: $localize`At what price would you think the product is a bargain - a great buy for the money? (Cheap/Good value)`,
          },
          {
            id: 'expensive',
            label: $localize`At what price would you think the product is not out of the question, but you would have to give it some thoughts? (Expensive)`,
          },
          {
            id: 'too-expensive',
            label: $localize`At what price would you think the price is so expensive that you would not consider buying it? (Too expensive)`,
          },
        ],
      },
    ],
    [
      {
        id: 'anything-else',
        title: $localize`Anything else you'd like to share`,
        subtitle: $localize`Please add add any other comments, ideas and change requests, you would like to share with us`,
        type: 'textarea',
      },
      {
        id: 'email',
        title: $localize`E-mail contact`,
        subtitle: $localize`In case we need more information, we would like to contact you on the e-mail address you gave us when signing up.`,
        type: 'consent',
        options: [
          { id: 'mail', label: $localize`By ticking this box you allow us to get in contact with you by e-mail.` },
        ],
      },
    ],
  ],
};
